/* SOELY NZ – BioChroma : galerie, offres, ajout au panier */
(function () {
  function init() {
    var main = document.querySelector('.bcg__main'), thumbs = document.querySelectorAll('.bcg__t');
    if (main) {
      var go = function (i) { var s = main.children[i]; if (s) main.scrollTo({ left: s.offsetLeft - main.children[0].offsetLeft, behavior: 'smooth' }); };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.i); }); });
      var tm; main.addEventListener('scroll', function () {
        clearTimeout(tm); tm = setTimeout(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
          var on = thumbs[i]; if (on) on.parentElement.scrollTo({ left: on.offsetLeft - 40, behavior: 'smooth' });
        }, 80);
      }, { passive: true });
    }
    var bars = document.querySelectorAll('.bcpage .kaching-bundles__bar'), qty = document.querySelector('.bcpage .bc-qty');
    function pick(b) {
      bars.forEach(function (x) { var on = x === b; x.classList.toggle('kaching-bundles__bar--selected', on); var i = x.querySelector('input'); if (i) i.checked = on; });
      if (qty) qty.value = b.dataset.qty || 1;
    }
    bars.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); pick(b); }); });
    var sel = document.querySelector('.bcpage .kaching-bundles__bar--selected') || bars[1] || bars[0]; if (sel) pick(sel);
    var form = qty && qty.closest('form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.bc-atc'), err = form.querySelector('.bc-err'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +form.querySelector('[name=id]').value, quantity: +qty.value }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Error'); return j; }); })
        .then(function () {
          if (typeof window.openMoonBundleCartDrawer === 'function') { window.openMoonBundleCartDrawer(); return; }
          var d = document.querySelector('cart-drawer');
          if (d && d.open) { fetch('/?sections=' + d.dataset.sectionId).then(function (r) { return r.json(); }).then(function (s) {
            return import('@theme/events').then(function (m) { document.dispatchEvent(new m.CartUpdatedEvent({}, { source: 'product-form', sections: s })); }); }).catch(function () { location.href = '/cart'; }); return; }
          location.href = '/cart';
        })
        .catch(function (x) { if (err) { err.hidden = false; err.textContent = x.message; } })
        .finally(function () { btn.disabled = false; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
